export const cookieMatcher = (key = "userInfo") => {
    return document.cookie.match(`(^|;)\\s*${key}\\s*=\\s*([^;]+)`);
}
